/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Popover } from '@mui/material';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';
import { Theme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import DownArrowIcon from '@mui/icons-material/KeyboardArrowDown';
import * as React from 'react';
import './NavMenu.css';
const styles = (theme: Theme) => ({
    root: {
        display: 'flex',
    },
    paper: {
        marginRight: (theme && typeof (theme as any).spacing === 'function') ? (theme as any).spacing(2) : '16px',
    },
    MuiButtonBase: {
        backgroundColor: '#000000'
    },
    MuiButton: {
        backgroundColor: '#000000'
    },
    menuList: {
        padding: '0px'
    },
    menuItem: {
        width: 'auto',
        minWidth: 'unset',
        justifyContent: 'left',
        fontSize: '13px',
        padding: '11px 16px'
    }
});

interface Props {
    classes?: any,
    listItems: Array<object>,
    onClick: Function,
    isDisabled?: boolean;
    selectTitle: string;
    selectedItem?: any;
    displaySelectedItemInTitle?: boolean;
}

class MenuListComposition extends React.PureComponent<Props, any> {
    state = {
        open: false,
    };

    handleToggle = () => {
        this.setState({ open: !this.state.open });
    };

    handleClose = (event: any) => {
        if (this.anchorEl.contains(event.target)) {
            return;
        }

        this.setState({ open: false });
    };
    handleClick = (event: any) => {
        if (this.anchorEl.contains(event.target)) {
            return;
        }
        this.setState({ open: false });
        this.props.onClick(event.target.value);
    };
    anchorEl: any;

    render() {
        const { classes } = this.props;
        const { open } = this.state;
        return (
            <div className={classes.root}>

                <div>
                    <Button
                        variant="outlined" style={{ backgroundColor: '#ffffff' }}
                        ref={(node: HTMLButtonElement | null) => {
                            this.anchorEl = node;
                        }}
                        aria-owns={open ? 'c' : undefined}
                        aria-haspopup="true"
                        disabled={this.props.isDisabled === undefined ? false : this.props.isDisabled}
                        onClick={this.handleToggle}
                    >
                        <div>
                            {`${this.props.selectTitle}${this.props.displaySelectedItemInTitle !== true ? '' : ':' + this.props.selectedItem}`}
                            <DownArrowIcon />
                        </div>
                    </Button>
                    <Popover open={open} anchorEl={this.anchorEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}>
                        <Paper style={{ minWidth: this.anchorEl ? this.anchorEl.offsetWidth : undefined }}>
                            <ClickAwayListener onClickAway={this.handleClose}>
                                <MenuList className={classes.menuList}>
                                    {this.props.listItems.map((x: any) => {
                                        return (
                                            <MenuItem className={classes.menuItem} key={x.id} value={x.id} onClick={this.handleClick}>{x.name}</MenuItem>
                                        );
                                    })}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Popover>
                </div>
            </div>
        );
    }
}


export default withStyles(styles)(MenuListComposition);
